module.exports = __webpack_public_path__ + "img/vote-9@2x.09e3e678.png";